const PORTAL_NAME = {
  HOST_PORTAL: 'HOST_PORTAL',
  PARTNER_PORTAL: 'PARTNER_PORTAL'
};

const PORTAL_SUB_DOMAIN_PREFIX = {
  HOST_PORTAL: '',
  PARTNER_PORTAL: 'partner'
};

const ROOT_DOMAIN = 'hafla.com';

const env = process.env.NEXT_PUBLIC_APP_ENV ?? 'development';
const envDomainPrefix = process.env.NEXT_PUBLIC_ENV_DOMAIN_PREFIX ?? 'local';
const nginxPort = process.env.NEXT_PUBLIC_NGINX_PORT ?? '8080';
const protocol = process.env.NEXT_PUBLIC_PORTAL_SCHEME ?? 'http';

const HOST_API_PATH_PREFIX = '/api';

const PARTNER_API_PATH_PREFIX = '/api/partner_app';

const getFQDN = ({
  portalName = PORTAL_NAME.HOST_PORTAL,
  requestWWWSubdomainPrefix = env === 'production'
}) => {
  const domainName = [envDomainPrefix, ROOT_DOMAIN].filter(Boolean).join('.');

  const prefixWWWToSubdomain =
    requestWWWSubdomainPrefix && portalName === PORTAL_NAME.HOST_PORTAL;

  const wwwPrefix = prefixWWWToSubdomain ? 'www' : '';

  const fqdnWithoutWWW = [PORTAL_SUB_DOMAIN_PREFIX[portalName], domainName]
    .filter(Boolean)
    .join('.');

  return [wwwPrefix, fqdnWithoutWWW].filter(Boolean).join('.');
};

const getURLOrigin = ({
  portalName = PORTAL_NAME.HOST_PORTAL,
  requestWWWSubdomainPrefix = env === 'production'
} = {}) => {
  const fqdn = getFQDN({ portalName, requestWWWSubdomainPrefix });
  const authority = [fqdn, nginxPort].filter(Boolean).join(':');
  return `${protocol}://${authority}`;
};

const PARTNER_PORTAL_FQDN = getFQDN({
  portalName: PORTAL_NAME.PARTNER_PORTAL
});

const HOST_PORTAL_URL = getURLOrigin();

const PARTNER_API_BASE_URL = `${getURLOrigin()}${PARTNER_API_PATH_PREFIX}`;

const HOST_API_BASE_URL = `${getURLOrigin()}${HOST_API_PATH_PREFIX}`;

const PARTNER_PORTAL_URL = getURLOrigin({
  portalName: PORTAL_NAME.PARTNER_PORTAL
});

module.exports = {
  HOST_PORTAL_URL,
  HOST_API_BASE_URL,
  PARTNER_API_BASE_URL,
  PARTNER_PORTAL_FQDN,
  PARTNER_PORTAL_URL,
  ROOT_DOMAIN
};
